import { environment } from 'environments/environment';

/**
 * Project name constants
 * These represent the different projects/clients in the AVE ecosystem
 */
export enum ProjectName {
  CORTIJO = 'CORTIJO',
  DIUNSA = 'DIUNSA',
  PORTUGAL = 'PORTUGAL',
  PHRYMA = 'PHRYMA',
  ALASKA = 'ALASKA'
}

/**
 * Checks if the current project is Portugal or Phryma
 * Used for project-specific feature toggles
 */
export function isPortugalOrPhrymaProject(): boolean {
  const projectName = environment.projectName?.toLowerCase();
  return projectName === ProjectName.PORTUGAL.toLowerCase() ||
         projectName === ProjectName.PHRYMA.toLowerCase();
}

/**
 * Checks if returnable column should be displayed
 * Returnable column is hidden for Portugal and Phryma projects
 */
export function shouldShowReturnableColumn(): boolean {
  return !isPortugalOrPhrymaProject();
}
